import React from 'react';
import SectionTitle from '../common/SectionTitle';
import ServiceCard from '../common/ServiceCard';
import { BookOpen, FileText, Users, Award, BookMarked } from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      id: 'counselling',
      title: 'Admission Counselling',
      description: 'Personalized guidance to help you choose the right veterinary college based on your preferences, budget, and career goals.',
      icon: <Users size={32} />
    },
    {
      id: 'application',
      title: 'Application Assistance',
      description: 'Complete support with the application process, including form filling, document preparation, and submission to multiple colleges.',
      icon: <FileText size={32} />
    },
    {
      id: 'document',
      title: 'Documentation Support',
      description: 'Expert help with compiling and organizing all necessary documents required for BVSc admissions, ensuring nothing is missed.',
      icon: <BookMarked size={32} />
    },
    {
      id: 'interview',
      title: 'Interview Preparation',
      description: 'Comprehensive preparation for college interviews, including mock sessions and guidance on common veterinary admission questions.',
      icon: <BookOpen size={32} />
    },
    {
      id: 'scholarship',
      title: 'Scholarship Guidance',
      description: 'Information and assistance with scholarship applications to help make your veterinary education more affordable.',
      icon: <Award size={32} />
    }
  ];

  return (
    <section id="services-section" className="section bg-gray-50">
      <div className="container-custom">
        <SectionTitle 
          title="Our Services" 
          subtitle="We provide comprehensive support for BVSc admissions, from counselling to enrollment and beyond."
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map(service => (
            <ServiceCard 
              key={service.id}
              id={service.id}
              title={service.title}
              description={service.description}
              icon={service.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;